module.exports = __webpack_public_path__ + "static/media/logo_im.46c20311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_im.svg
// module id = 3376
// module chunks = 0